// extracted by mini-css-extract-plugin
module.exports = {"inputs":"CodeInput_inputs__E1CSX","label":"CodeInput_label__p74xb"};